import { enterKey } from "@repo/helpers";
import { useEffect, useRef } from "react";

/**
 * Tries to handle enter a key like tab key (goes to next field), for mobile usage
 * @param onLastField Function
 */
export function useEnterJump(onLastField: () => void) {
	const callback = useRef<() => void>(onLastField);
	useEffect(() => {
		document.addEventListener("keydown", onEnter);
		return unmount;
	}, []);

	useEffect(() => {
		callback.current = onLastField;
	}, [onLastField]);

	function unmount() {
		document.removeEventListener("keydown", onEnter);
	}

	function onEnter(e?: KeyboardEvent) {
		return enterKey(onEnterFn)(e);
	}

	function onEnterFn(e?: KeyboardEvent) {
		const currentElement = e.target as SelectableEl;
		let found = false;
		let nextElement: SelectableEl = null;

		const allElements = document.querySelectorAll<SelectableEl>("input,select,textarea");
		for (const el of allElements) {
			if (found && !el.disabled) {
				nextElement = el;
				break;
			}
			if (el === currentElement) found = true;
		}

		let parent = nextElement as HTMLElement;
		while ((parent = parent?.parentElement)) {
			if (parent.style.display === "none") {
				nextElement = null;
				break;
			}
		}
		if (nextElement) nextElement.focus();
		else callback.current();
	}
}

declare type SelectableEl = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
